import { Helmet } from "react-helmet";
import { UsersIcon } from "@heroicons/react/24/outline";
import { TablePartnersList } from "../../tables/partners.list";

import { SectionHeader } from "../../components/layouts/section.header";
import { SectionSubHeader } from "../../components/layouts/section.subheader";

export const ScreenPartnersList = () => {
  return (
    <>
      <Helmet>
        <title>List Partner</title>
      </Helmet>

      <div className="min-h-screen w-full">
        <SectionHeader title="List Partner" />

        <div className="mt-10">
          <SectionSubHeader
            Icon={UsersIcon}
            title="All Strategic Partners"
          />

          <TablePartnersList />
        </div>
      </div>
    </>
  );
};
